import { HttpClient } from '@angular/common/http';

import { makeStateKey, StateKey, TransferState } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';


/** copy from https://andremonteiro.pt/ngx-translate-angular-universal-ssr/ */
export class TranslateBrowserLoaderService implements TranslateLoader {
  private _translations$: {[key: string]: Observable<any>} = {};

  constructor(
    private http: HttpClient,
    private transferState: TransferState,
  ) {}

  public getTranslation(lang: string): Observable<any> {
    const key = makeStateKey<{[key: string]: any}>(
      'transfer-translate-' + lang
    );
    const data = this.transferState.get(key, null);

    // First we are looking for the translations in transfer-state,
    // if none found, http load as fallback
    if (data) {
      return new Observable((observer) => {
        observer.next(data);
        observer.complete();
      });
    }
    if (lang in this._translations$) {
      return this._translations$[lang];
    }
    this._translations$[lang] = new TranslateHttpLoader(this.http).getTranslation(lang).pipe(
      publishReplay(1),
      refCount(),
    );
    return this._translations$[lang];
  }
}

export function translateBrowserLoaderFactory(
  httpClient: HttpClient,
  transferState: TransferState,
) {
  return new TranslateBrowserLoaderService(httpClient, transferState);
}
